import { PLAN_EXTRAS } from "./constants";
import { IPlanExtra } from "./types";

export function isStarterPlan(alias: string): boolean {
  return alias.includes("starter");
}

export function isProPlan(alias: string): boolean {
  return alias.includes("pro-") || alias === "pro";
}

export function isEnterprisePlan(alias: string): boolean {
  return alias.includes("enterprise-");
}

export function isSelfHostedPlan(alias: string): boolean {
  return !(alias.includes("-cloud") || alias.includes("starter"));
}

export function isYearlyPlan(alias: string): boolean {
  return alias.includes("-yearly");
}

export function isDevPlan(alias: string): boolean {
  return alias.includes("-dev");
}

export function formatPlanShortName(shortName: string): string {
  return shortName.replace("Cloud", "").replace("Self-Hosted", "").trim();
}

export function getPlanExtra(alias: string): IPlanExtra | undefined {
  return PLAN_EXTRAS[alias];
}
